import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { Platform, StyleSheet, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import AsyncStorage from '@react-native-async-storage/async-storage';

import Colors from '../../constants/Colors';
import Languages from '../../constants/Languages';
import Layout from '../../constants/Layout';
import * as Actions from '../../store/Actions';
import Header from '../../components/register/Header';
import PasswordField from '../../components/register/PasswordField';
import FilledButton from '../../components/FilledButton';
import MyScrollView from '../../components/MyScrollView';
import PtfKeyboardAvoidingView from '../../components/PtfKeyboardAvoidingView';

import { AppText } from '../../components/AppText';

const styles = StyleSheet.create({
  container: {
    backgroundColor: Colors.mediumBlue,
  },
  mainContentContainer: {
    alignItems: 'center',
    backgroundColor: Colors.white,
  },
  topContainer: {
    alignItems: 'center',
  },
  passwordContainer: {
    width: 328,
    marginTop: Layout.isSmall ? 80 : 100,
  },
  headingText: {
    fontSize: Layout.isSmall ? 20 : 26,
    fontWeight: '500',
    color: Colors.veryDarkGray,
    fontFamily: 'roboto-regular',
    textAlign: 'center',
    marginTop: Layout.isSmall ? 53 : 34,
  },
  title: {
    fontFamily: 'roboto-regular',
    fontSize: 26,
    textAlign: 'center',
    marginBottom: 31,
  },
  text: {
    fontFamily: 'roboto-regular',
    fontSize: Layout.isSmall ? 14 : 16,
    color: Colors.veryDarkGray,
    textAlign: 'center',
    marginTop: 8,
    width: 328,
  },
  signupContainer: Layout.signupContainer,
  signupFooter: Layout.signupFooter,
});

class CreatePasswordScreen extends Component {
  static propTypes = {
    registration: PropTypes.objectOf(PropTypes.any).isRequired,
    actions: PropTypes.objectOf(PropTypes.any).isRequired,
    navigation: PropTypes.objectOf(PropTypes.any).isRequired,
  };

  constructor(props) {
    super();
    this.state = {
      password: '',
      isValid: false,
    };
  }

  goBack = () => {
    const { navigation } = this.props;
    navigation.navigate('Language');
  };

  goNext = () => {
    const { actions, registration, navigation } = this.props;
    const { password } = this.state;
    const { flow } = registration;
    let email = null;
    let resetToken;
    if (Platform.OS === 'web') {
      const params = new URL(document.location).searchParams;
      resetToken = params.get('reset');
    }
    if (get(registration, 'emailOrPhoneResult.email')) {
      email = registration.emailOrPhoneResult.email;
    } else if (get(registration, 'enterEmail.results.email')) {
      email = registration.enterEmail.results.email;
    }
    actions.createPassword(email, password, resetToken, (user) => {
      if (user === 'reset') {
        navigation.navigate('PhoneOrEmail');
      } else if (flow === 'new_email') {
        // if new email, go to phone
        navigation.navigate('EnterPhone');
      } else if (user.docs && user.docs.length) {
        // if terms and conditions needed
        navigation.navigate('TermsPrivacy');
      } else if (!user.onboarding_complete) {
        // if onboarding not finished, onboarding
        navigation.navigate('UserDetails');
      } else {
        AsyncStorage.setItem('onboarded', '1').then(() => {
          navigation.navigate('a');
        });
      }
    });
  };

  onUpdateText = (params) => {
    this.setState({
      password: params.password,
      isValid: params.isValid,
    });
  };

  render() {
    const { registration } = this.props;
    const { isValid } = this.state;
    const { language } = registration;
    const translation = Languages.translations[language?.name || 'en'];

    return (
      <SafeAreaView style={{ flex: 1 }} edges={['top', 'left', 'right', 'bottom']}>
        <PtfKeyboardAvoidingView style={{ flex: 1 }}>
          <MyScrollView
            contentContainerStyle={styles.mainContentContainer}
            containerStyle={styles.container}
            testID="create-password"
          >
            <Header title={translation.create_password} goBack={this.goBack} />
            <View style={styles.signupContainer}>
              <View style={styles.topContainer}>
                <View style={styles.passwordContainer}>
                  {Layout.isSmall ? null : (
                    <AppText style={styles.title}>{translation.create_password}</AppText>
                  )}
                  <PasswordField onTextChange={this.onUpdateText} translation={translation} createPassword />
                </View>
              </View>
              <View style={styles.signupFooter}>
                <FilledButton
                  onPress={this.goNext}
                  label={translation.submit}
                  color={Colors.primaryColor}
                  full
                  textColor={Colors.white}
                  disabled={!isValid}
                />
              </View>
            </View>
          </MyScrollView>
        </PtfKeyboardAvoidingView>
      </SafeAreaView>
    );
  }
}

function mapStateToProps(state) {
  return {
    registration: state.registration,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Actions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CreatePasswordScreen);
